import { selectAtom } from "jotai/utils";
import { baseAtom, setViewTemplatesOpen } from "../../../stores/jotai/base";
import TemplateEditorModal from "./TemplateEditorModal";
import { useAtom, useSetAtom } from "jotai";
import {
  setSelectedTemplate,
  templatesAtom,
} from "../../../stores/jotai/template/templates";
const viewTemplatesOpenAtom = selectAtom(
  baseAtom,
  (base) => base.viewTemplatesOpen
);
const TemplateListModal = () => {
  const [viewTemplatesOpen] = useAtom(viewTemplatesOpenAtom);
  const setTemplateAtomState = useSetAtom(templatesAtom);
  const [base, setBase] = useAtom(baseAtom);

  return (
    <TemplateEditorModal
      open={viewTemplatesOpen}
      handleDialogClose={() => {
        setViewTemplatesOpen(setBase, false);
        setSelectedTemplate(setTemplateAtomState, null);
      }}
      setBase={setBase}
    />
  );
};

export default TemplateListModal;
